/**
 * Calendar Toolbar Component
 * 
 * Navigation controls and view switcher for the calendar
 */

import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { CalendarToolbarProps } from '../../types/calendar';
import { formatHeaderDate } from '../../utils/calendarHelpers';
import { VIEW_LABELS } from './CalendarConfig';

export const CalendarToolbar: React.FC<CalendarToolbarProps> = ({
  currentDate,
  currentView,
  onNavigate,
  onViewChange,
  views,
}) => {
  return (
    <div className="bg-white border-b border-gray-200 px-4 py-3">
      {/* Single Row: Navigation, Date Display, and View Switcher */}
      <div className="flex items-center justify-between">
        {/* Navigation Controls (Left) */}
        <div className="flex items-center space-x-2">
          <button
            onClick={() => onNavigate('PREV')}
            className="p-2 hover:bg-gray-100 rounded-md transition-colors"
            aria-label="Previous"
          >
            <ChevronLeft className="w-5 h-5 text-gray-600" />
          </button>
          
          <button
            onClick={() => onNavigate('TODAY')}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium text-sm"
          >
            Today
          </button>
          
          <button
            onClick={() => onNavigate('NEXT')}
            className="p-2 hover:bg-gray-100 rounded-md transition-colors"
            aria-label="Next"
          >
            <ChevronRight className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        {/* Current Date Display (Center) */}
        <h2 className="text-xl font-semibold text-gray-900">
          {formatHeaderDate(currentDate, currentView)}
        </h2>

        {/* View Switcher (Right) */}
        <div className="flex space-x-1">
          {views.map((view) => (
            <button
              key={view}
              onClick={() => onViewChange(view)}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                currentView === view
                  ? 'bg-blue-100 text-blue-700'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              {VIEW_LABELS[view]}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

